import Register from './src/Register.vue';

Register.install = function (app) {
  app.component(Register.name, Register)
}

export default Register


//////////////////
// WEBPACK FOOTER
// ./packages/register/index.js
// module id = null
// module chunks = 